import { render, staticRenderFns } from "./trainerH1.vue?vue&type=template&id=5d7a071e&"
import script from "./trainerH1.vue?vue&type=script&lang=js&"
export * from "./trainerH1.vue?vue&type=script&lang=js&"
import style0 from "./trainerH1.scss?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports